import { useMutation } from "@apollo/client";
import styled from "@emotion/styled";
import React, { useState } from "react";
import { RootState, i18n, useAppSelector } from "src/common";
import { sendOffersToEmail } from 'src/common/api/apollo/supplementary';
import { Button, Flex, Label, Text } from 'src/components';
import { colors } from "src/theme";
import { Card } from "./card";

const TextStyle = styled(Text)({
  color: colors.text2,
  textWrap: 'initial'
})

interface SendOffersToEmailCardProps {
  className?: string;
}

export const SendOffersToEmailCard = ({ className }: SendOffersToEmailCardProps) => {
  // The server takes the recipient from the SO, so the SO id is all we send.
  const { soIdWeb, soId } = useAppSelector((store: RootState) => store.model.offer);
  const activeSoId = soIdWeb ?? soId;

  const [isSendOffersDisabled, setIsSendOffersDisabled] = useState(false);
  const [sendOffersToEmailMutation] = useMutation(sendOffersToEmail);

  const sendOffers = () => {
    if (!activeSoId) return;
    setIsSendOffersDisabled(true);
    sendOffersToEmailMutation({ variables: { soId: activeSoId } })
      .catch(() => setIsSendOffersDisabled(false));
  }

  // No SO means nothing to attach the send to — this happens when a visitor
  // arrives on a `?param=` link without a `soId`. The server would refuse, so
  // offering the button would just be a control that never works.
  if (!activeSoId) return null;

  return (
    <Card radius={12} padding={16} className={className}>
      <Flex vertical gap={12}>
        <Label type='small'>{i18n.t('components.cards.SendOffersToEmailCard.notSure')}</Label>
        <Button style={{ backgroundColor: colors.success2, borderColor: colors.success2 }} onClick={sendOffers} disabled={isSendOffersDisabled}>
          <TextStyle type="base" bold>{i18n.t(`components.cards.SendOffersToEmailCard.${isSendOffersDisabled ? 'sendOffersDisabled' : 'sendOffers'}`)}</TextStyle>
        </Button>
      </Flex>
    </Card>
  )
};
